import { createAsyncThunk } from '@reduxjs/toolkit'
import { newProjectActions } from '../newProjectReducer'
import { subscribeToUpdates } from './liveUpdatesActions'

export const subscribeToProjectOperationsLogs = createAsyncThunk<
  any,
  any,
  { state: any }
>(
  'project-operations/subscribeToUpdates',
  async (groupName: string, thunkAPI) => {
    // let signalrHandlerCount = 0

    thunkAPI.dispatch(
      subscribeToUpdates({
        groupName,
        clientMethodName: 'onProjectOperationProgress',
        clientMethod: () => {
          // console.log('[OPERATIONS] message handler', ++signalrHandlerCount)
          // const t = performance.now()

          thunkAPI.dispatch(
            newProjectActions.updateOperationsFlags({
              shallUpdateOperationsSummary: true,
              shallUpdateOperationsLogs: true,
            })
          )

          // console.log(
          //   '[OPERATIONS] endsOperationsHandler',
          //   (performance.now() - t) / 1000
          // )
        },
      })
    )
  }
)
